import React from "react";
import "./RegisterBanner.css";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const RegisterBanner = () => {
      const navigate = useNavigate();
  return (
    <div className="register-banner">
      <div className="register-banner-left">
        <h2>
          Find more relevant jobs? <span>register for free!</span>
        </h2>

        <div className="register-banner-tags">
          <div className="register-tag">
            <FaCheckCircle />
            <span>Personalised recommendations</span>
          </div>

          <div className="register-tag">
            <FaCheckCircle />
            <span>Real-time updates</span>
          </div>

          <div className="register-tag">
            <FaCheckCircle />
            <span>Recruiters directly reach out</span>
          </div>

          <div className="register-tag">
            <FaCheckCircle />
            <span>Boost visibility</span>
          </div>
        </div>

        <button className="register-btn"       onClick={() => navigate("/getotp-jobseeker")}
>
          Register for Free
        </button>
      </div>

      <div className="register-banner-right">
       <img src="/assets/Images/logo/registration-card-bg.png" alt="Register Banner" className="circle_img"/>
      </div>
    </div>
  );
};

export default RegisterBanner;